import type { MutationHookOptions } from '@apollo/client'
import {
  UpdateElementDocument,
  UpdateElementMutation,
  UpdateElementMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<UpdateElementMutation, UpdateElementMutationVariables>

const useUpdateElement = (options?: Options) => {
  const [update, { loading }] = useMutation(UpdateElementDocument, {
    ...options,
    extractorFn: (data) => data.formsMutations.updateFormsElement,
  })

  return {
    loading,
    update(variables: UpdateElementMutationVariables) {
      return update({
        variables,
      })
    },
  }
}

export default useUpdateElement
